// extracted by mini-css-extract-plugin
export default {"thumbnail":"Thumbnail_thumbnail__k+Dyw","thumbnailPlaceholder":"Thumbnail_thumbnailPlaceholder__VcEsn","thumbnail-wrapper":"Thumbnail_thumbnail-wrapper__fj8pJ"};